<template>
  <div class="room-config-dialog">

    <el-dialog :title="isEdit ? '修改' : '新增'" :visible="value" width="580px" :before-close="handleClose">
      <el-form ref="form" :model="formData" label-width="100px">
        <div v-if="!isEdit">
          <el-alert title="文件不为空时使用导入文件作为rid" type="warning" style="margin-bottom: 10px;">
          </el-alert>
          <el-form-item label="主播rid">
            <el-upload class="avatar-uploader" action="" :auto-upload="false" :before-remove="removeFile"
              :on-change="addExcel" ref="upload">
              <el-button type="primary">一键导入</el-button>
            </el-upload>
          </el-form-item>

          <el-form-item label="主播rid">
            <el-input v-model="formData.ridStr"></el-input>
          </el-form-item>
        </div>
        <el-form-item label="房间类型">
          <el-select v-model="formData.roomType" placeholder="请选择房间类型" style="width: 100%;" :disabled="isEdit">
            <el-option label="直播" :value="1"></el-option>
            <el-option label="语聊" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <div v-if="isEdit">
          <el-form-item label="房间封面">
            <UploadSingleImg v-model="formData.roomCover" :on-upload="uploadFile" />
          </el-form-item>
          <el-form-item label="房间标题">
            <el-input v-model="formData.roomName"></el-input>
          </el-form-item>
          <el-form-item label="房间公告">
            <el-input v-model="formData.roomNotice"></el-input>
          </el-form-item>
        </div>
        <el-form-item label="增量热度值">
          <el-input v-model="formData.increaseHeat"></el-input>
        </el-form-item>
        <el-form-item label="置顶权重">
          <el-input v-model="formData.top"></el-input>
        </el-form-item>
        <el-form-item label="时间配置">
          <el-col :span="11">
            <el-date-picker type="datetime" placeholder="选择开始时间" value-format="yyyy-MM-dd HH:mm:ss"
              v-model="formData.startTime" style="width: 100%;"></el-date-picker>
          </el-col>
          <el-col class="line" :span="2" style="text-align: center;">-</el-col>
          <el-col :span="11">
            <el-date-picker type="datetime" placeholder="选择结束时间" value-format="yyyy-MM-dd HH:mm:ss"
              v-model="formData.endTime" style="width: 100%;"></el-date-picker>
          </el-col>
        </el-form-item>
        <el-form-item label="是否有效">
          <el-radio-group v-model="formData.valid">
            <el-radio :label="1">有效</el-radio>
            <el-radio :label="0">无效</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="$emit('input', false)">取 消</el-button>
        <el-button type="primary" @click="submitChange">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import UploadSingleImg from '@/components/UploadSingleImg/UploadSingleImg'
export default {
  components: {
    UploadSingleImg
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      formData: {
        file: '',
        ridStr: '',
        roomType: 1,
        increaseHeat: '',
        top: '',
        startTime: '',
        endTime: '',
        valid: 1

      }
    }
  },
  watch: {
    data: {
      deep: true,
      handler(newVal) {
        if (this.isEdit) {
          this.formData = this.data
        }
      }
    },
    isEdit(newVal) {
      if (!newVal) {
        this.formData = this.$options.data().formData
        console.log(this.formData);
      }
    }
  },
  methods: {
    removeFile() {
      console.log('removeFile');
      this.formData.file = '';
    },
    addExcel(file) {
      console.log('addExcel',file);
      this.formData.file = file.raw;
    },
    handleClose() {
      this.$emit('input', false)
    },
    submitChange() {
      this.$emit('submit', this.formData)
    },
    async uploadFile(file) {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('cover', 0)
      formData.append('dir', 'room/')
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.hostmgr_upload +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token,
        formData
      )
      return { code: res.code, url: res.data }
    },
  }
}
</script>

<style scoped lang="scss">
.room-config-dialog {
  :deep(.el-dialog) {
    border-radius: 10px;
  }
}
</style>